'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tradeTypes = require('./tradeTypes');

var _tradeTypes2 = _interopRequireDefault(_tradeTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (code) {
    var tradeType = _tradeTypes2.default.find(function (x) {
        return x.value === code;
    });
    return tradeType ? tradeType.text : 'Unknown';
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/trade/tradeTypeCodeToText.js
// module id = 29
// module chunks = 0